import type { ReactNode } from "react";

import { BasicTooltip } from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";

interface SmartTableStalenessIndicatorProps {
  label?: ReactNode;
  showLabel?: boolean;
  tooltipContent?: ReactNode;
  tooltipSide?: "top" | "bottom" | "left" | "right";
  tooltipDelayDuration?: number;
  className?: string;
  dotClassName?: string;
  labelClassName?: string;
  ariaLabel?: string;
}

const SmartTableStalenessIndicator = ({
  label = "Stale",
  showLabel = true,
  tooltipContent,
  tooltipSide = "top",
  tooltipDelayDuration = 300,
  className,
  dotClassName,
  labelClassName,
  ariaLabel = "Stale",
}: SmartTableStalenessIndicatorProps) => {
  const indicator = (
    <span
      className={cn(
        "inline-flex min-w-0 items-center gap-1.5 text-amber-700 dark:text-amber-300",
        className,
      )}
      aria-label={showLabel ? undefined : ariaLabel}
    >
      <span
        className={cn(
          "smart-table-stale-pending-dot h-1.5 w-1.5 shrink-0 rounded-full",
          dotClassName,
        )}
        aria-hidden="true"
      />
      {showLabel ? (
        <span className={cn("min-w-0 truncate text-[11px] font-medium leading-4", labelClassName)}>
          {label}
        </span>
      ) : null}
    </span>
  );

  if (!tooltipContent) {
    return indicator;
  }

  return (
    <BasicTooltip content={tooltipContent} side={tooltipSide} delayDuration={tooltipDelayDuration}>
      {indicator}
    </BasicTooltip>
  );
};

export default SmartTableStalenessIndicator;
